"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { deleteWardrobeCookies } from "../../utils/utils";
import { useResetAllStores } from "../../../lib/Hooks/useResetAllStores";
import useStore from "../../../lib/Store/useStore";
import { getAuthSession, validateUserToken } from "../../../lib/User/action";

const AppSideEffects = () => {
    const {
        flag,
        currency,
        resetCountryStore,
        setAuthSession,
        getCustomerData,
    } = useStore();
    const pathName = usePathname();
    const resetAllStores = useResetAllStores();

    useEffect(() => {
        const testUserToken = async () => {
            try {
                const authSession = await getAuthSession()
                if (authSession?.accessToken) {
                    setAuthSession({ session: authSession, status: "authenticated" });
                    const valid = await validateUserToken();
                    if (valid)
                        await getCustomerData();
                    else
                        resetAllStores({ logout: true });
                } else {
                    setAuthSession({ authSession, status: "unauthenticated" });
                }
            } catch (error) {
                console.error(error)
            }
        };
        testUserToken();
    }, []);

    useEffect(() => {
        if (!flag || !currency) resetCountryStore()
    }, [flag, currency])


    useEffect(() => {
        deleteWardrobeCookies(pathName);
    }, [pathName]);

    // No return statement since this is for side effects only
    return null;
};

export default AppSideEffects;
